<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row justify="space-between">
          <v-col md="2">
            <v-text-field
              v-model="filter.search"
              placeholder="Поиск по имени"
              dense
            />
          </v-col>
          <v-col md="4">
            <v-row>
              <v-col>
                <Select
                  label="Муниципалитет"
                  v-model="filter.municipality"
                  :items="municipalities"
                  item-text="short_name"
                  item-value="id"
                  class="fs-admin-complex-autocomplete"
                  @change="getDataFromFirstPage"
                  blank
                  dense
                  flat
                />
              </v-col>
              <v-col>
                <Select
                  label="Подключение"
                  v-model="filter.is_connected"
                  :items="connectionStates"
                  class="fs-admin-complex-autocomplete"
                  @change="getDataFromFirstPage"
                  blank
                  dense
                  flat
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <Table
          :headers="headers"
          :items="schools"
          :items-per-page="schoolsPerPage"
          :server-items-length="totalSchools"
          :page="page"
          :loading="loading"
          disable-sort
          @update:request="updateRequest"
          class="elevation-1"
        >
          <template v-slot:item.is_connected="{ item }">
            <v-icon
              :color="item.is_connected ? 'green' : 'red'"
              class="mr-2"
            >mdi-circle</v-icon>
          </template>
          <template v-slot:item.info="{ item }">
            <v-btn icon x-small @click="openInfoModal(item)">
              <v-icon>info</v-icon>
            </v-btn>
          </template>
        </Table>
      </v-card-text>
    </v-card>
    <Modal
      v-if="selectedSchool"
      :title="selectedSchool.name"
      :dialog.sync="modals.info"
      @update:dialog="selectedSchool = null"
      contentClass="esh-theme adminModal"
    >
      <template #body>
        <v-card
          outlined
          class="infoBody"
        >
          <v-card-text>
            <v-row>
              <v-col md="6">
                <h3 class="mb-2">Всего</h3>
                <ul>
                  <li>В школе: {{ selectedSchool.stat.users.in_unit }}</li>
                  <li>Выдано карт: {{ selectedSchool.stat.users.all_cards }}</li>
                  <li>С картой: {{ selectedSchool.stat.users.with_card }}</li>
                  <li>Пользователей: {{ selectedSchool.stat.users.all }}</li>
                </ul>
              </v-col>
              <v-col md="6">
                <h3 class="mb-2">Ученики</h3>
                <ul>
                  <li>В школе: {{ selectedSchool.stat.pupils.in_unit }}</li>
                  <li>Выдано карт: {{ selectedSchool.stat.pupils.all_cards }}</li>
                  <li>С картой: {{ selectedSchool.stat.pupils.with_card }}</li>
                  <li>Всего: {{ selectedSchool.stat.pupils.all }}</li>
                </ul>
              </v-col>
              <v-col md="6">
                <h3 class="mb-2">Учителя</h3>
                <ul>
                  <li>В школе: {{ selectedSchool.stat.teachers.in_unit }}</li>
                  <li>Выдано карт: {{ selectedSchool.stat.teachers.all_cards }}</li>
                  <li>С картой: {{ selectedSchool.stat.teachers.with_card }}</li>
                  <li>Всего: {{ selectedSchool.stat.teachers.all }}</li>
                </ul>
              </v-col>
              <v-col md="6">
                <h3 class="mb-2">Гости</h3>
                <ul>
                  <li>В школе: {{ selectedSchool.stat.guests.in_unit }}</li>
                  <li>Выдано карт: {{ selectedSchool.stat.guests.all_cards }}</li>
                </ul>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </Modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { BASE } from '@/config'
import { Table, Modal, Select } from '@/components/common'
import { GET_SCHOOLS_STAT, GET_SUGGESTION_MUNICIPALITIES } from '@/requests/superadmin'

export default {
  name: 'StatSchollsSuperAdmin',
  components: {
    Table,
    Modal,
    Select
  },
  data() {
    return {
      headers: [
        { text: 'Наименование', value: 'name' },
        { text: 'Подключение к системе', value: 'is_connected' },
        { text: 'Пользователей', value: 'stat.users.all' },
        { text: 'С картой', value: 'stat.users.with_card' },
        { text: 'Выдано карт', value: 'stat.users.all_cards' },
        { text: 'Присутсвие в школах', value: 'stat.users.in_unit' },
        { text: 'Подробнее', value: 'info' },
      ],
      loading: false,
      schools: [],
      page: 1,
      totalSchools: 0,
      schoolsPerPage: BASE.LIMIT,
      selectedSchool: null,
      municipalities: [],
      connectionStates: [
        { text: 'Подключена', value: true },
        { text: 'Не подключена', value: false }
      ],
      filter: {
        search: '',
        is_connected: null,
        municipality: null
      },
      modals: {
        info: false
      }
    }
  },
  mounted() {
    this.getData()
    this.loadMunicipalities()
  },
  watch: {
    'filter.search': function(state, prevState) {
      if (state.length > prevState.length && state.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchSchools()
      } else if (state.length < prevState.length && prevState.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchSchools()
      }
    }
  },
  methods: {
    openInfoModal(item) {
      this.selectedSchool = item
      this.modals.info = true
    },
    searchSchools: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    updateRequest({ page, itemsPerPage, offset }) {
      this.schoolsPerPage = itemsPerPage
      this.page = page
      this.getData({ offset })
    },
    getDataFromFirstPage() {
      this.page = 1
      this.getData()
    },
    async getData(params = {}) {
      try {
        this.loading = true
        const { data: { count, results } } = await GET_SCHOOLS_STAT({
          limit: this.schoolsPerPage,
          name: this.filter.search.length >= BASE.SEARCH_MIN_LETTERS ? this.filter.search : '',
          district: this.filter.municipality,
          is_connected: this.filter.is_connected,
          ...params
        })

        this.schools = results
        this.totalSchools = count
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить статистику по школам'
        })
      } finally {
        this.loading = false
      }
    },
    async loadMunicipalities() {
      try {
        const { data: { results } } = await GET_SUGGESTION_MUNICIPALITIES()
        this.municipalities = results
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось получить список муниципалитетов'
        })
      }
    }
  }
}
</script>